import api from '../axiosInstance';
import { LOGS_ENDPOINTS } from '../constants';

export const CustomersLog = (customerId) => {
  const data = {
    customer_id : customerId
  }
  return api.post(LOGS_ENDPOINTS.LIST, data);
}